import React from 'react';
import { ArrowRight } from 'lucide-react';
import './ctaSection.css';
import { useNavigate } from 'react-router-dom';

export default function CTASection() {
  const navigate = useNavigate()
  return (
   <div className="   sm:w-full  flex flex-col md:items-center md:justify-center">
  {/* Mobile View */}
  <div className="md:hidden w-[91vw] dotted-bg py-10"> {/* Removed 'items-center justify-center', added 'pt-4' */}
    <div className="cta-bg-img rounded-3xl px-6 py-14 text-white max-w-sm mx-auto shadow-2xl flex flex-col items-center justify-around h-full">
      {/* Heading */}
      <div className="text-center mb-6">
        <h1 className="text-4xl xs:text-3xl font-pp-hatton italic font-bold leading-tight">
          Ready to Power <br />
          Your Dreams?
        </h1>
      </div>

      {/* Description */}
      <div className="mb-8 flex justify-center items-center">
        <p className="text-emerald-50 leading-relaxed text-2xl xs:text-xl max-w-[80%] font-atkinson text-center">
          Your financial freedom is just a click away.{" "}
          <strong>No delays.</strong> <strong>No hidden charges.</strong> Just{" "}
          <em className="italic font-semibold">fast, flexible, and reliable</em>{" "}
          personal loans—when you need them.
        </p>
      </div>

      {/* CTA Button */}
      <div className="text-center">
        <button
          onClick={() => {
            navigate('/personal-loan-v5?aff_id=1')
          }}
          className="bg-[#12F280] text-black font-atkinson py-3 xs:py-2 px-6 xs:px-4  rounded-full flex items-center justify-center gap-2 w-full transition-all duration-300 transform hover:scale-105 shadow-lg text-xl  xs:text-sm"
        >
          Apply Now
          <img src='/assets/img/Layer_1 (10).png' className='w-[30px] xs:w-[18px]' />
        </button>

        <p className="text-[#12F280] text-lg mt-3 opacity-80 font-atkinson">
          & Get Instant Approval!
        </p>
      </div>
    </div>
  </div>

  {/* Desktop View */}
  <div className="hidden md:flex dotted-bg w-full min-h-screen justify-center items-center">
    <div className="h-[70vh] cta-bg-img rounded-3xl w-full max-w-6xl mx-auto shadow-2xl flex flex-col justify-around px-8 py-12 text-white">
      <h1 className="text-4xl lg:text-[2.8rem] font-pp-hatton italic leading-tight text-center lg:text-left">
        Ready to Power Your Dreams?
      </h1>

      <p className="text-emerald-50 text-base lg:text-3xl leading-relaxed max-w-4xl mx-auto text-center lg:text-left font-atkinson">
        Your financial freedom is just a click away.{" "}
        <strong>No delays.</strong> <strong>No hidden charges.</strong> Just{" "}
        <em className="italic font-pp-hatton">fast, flexible, and reliable</em>{" "}
        personal loans—when you need them.
      </p>

      <div className="text-center">
        <button 
         onClick={() => {
            navigate('/personal-loan-v4?aff_id=1')
          }}
         className="bg-[#12F280] text-black font-atkinson py-2.5 px-8 rounded-full inline-flex items-center gap-3 transition-all duration-300 transform hover:scale-105 shadow-lg text-lg">
          Apply Now & Get Instant Approval!
          <img src="/assets/img/Layer_1 (10).png" width={27} />
        </button>
      </div>
    </div>
  </div>
</div>

  );
}
